type FormDescriptionProps = {
  description: string;
};

export default function FormDescription({ description }: FormDescriptionProps) {
  return <div className="mb-3 text-sm">{description}</div>;
}
